import React, { memo as Memo } from 'react'
const Icon = Memo((props) => {
	return (
		<i onClick={props.onClick} className={props.className}>
			{props.children}
		</i>
	)
})
export default Icon
